import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "px-4 text-black py-2 color-unset lineheight-unset"
};
const _hoisted_2 = {
  class: "flex items-center"
};
const _hoisted_3 = {
  class: "flex justify-between sm:flex-col md:flex-col lg:flex-row gap-2 items-start pl-4 overflow-auto full-height"
};
const _hoisted_4 = {
  class: "w-full lg:w-1/2 px-20"
};
const _hoisted_5 = {
  class: "mb-6 flex justify-between items-center"
};
const _hoisted_6 = {
  class: "w-full lg:w-1/2"
};
const _hoisted_7 = {
  class: "bg-green-50 mt-10 flex justify-between items-center border p-8 rounded-md shadow-sm mb-8"
};
const _hoisted_8 = {
  key: 0,
  class: "p-5"
};
const _hoisted_9 = {
  class: "text-center"
};
import { reactive } from 'vue';
import { storeToRefs } from 'pinia';
import { useImportStore } from '../import/useImportStore';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import ExportJson from '@/services/ExportJsonService';
export default {
  __name: 'ExpenseImport',
  props: {
    state: {
      type: Object,
      required: true
    },
    leanLawAuth: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const {
      imports,
      loading
    } = storeToRefs(useImportStore());
    const {
      listImports,
      initiateSession,
      deleteImport,
      completeImport
    } = useImportStore();
    const state = reactive({
      undoDialog: false,
      selectedItemId: null,
      result: null
    });
    listImports();
    const goBack = () => {
      props.state.go('^');
    };
    const displayCount = item => {
      return item.counts ? item.counts.primary : '-';
    };
    const downloadMatters = () => {
      const url = `${props.leanLawAuth.domain}/v1/export/clientMatterReference`;
      window.open(url, '_blank');
    };
    const expenseImports = imports => {
      return imports.filter(item => item.template === 'expense');
    };
    const undoItem = async () => {
      state.undoDialog = false;
      state.result = await deleteImport(state.selectedItemId);
    };
    const confirmUndo = itemId => {
      state.selectedItemId = itemId;
      state.undoDialog = true;
    };
    const confirmComplete = itemId => {
      state.selectedItemId = itemId;
      state.completeDialog = true;
    };
    const completeItem = async () => {
      state.completeDialog = false;
      state.result = await completeImport(state.selectedItemId);
    };
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_table = _resolveComponent("v-table");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(LlSecondaryButton, {
        variant: "text",
        onBtnClick: _cache[0] || (_cache[0] = $event => goBack()),
        class: "my-2",
        "prepend-icon": "mdi-arrow-left"
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" Back ", -1)]))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[10] || (_cache[10] = _createElementVNode("h1", {
        class: "text-2xl text-black font-semibold mb-4"
      }, "Expense import", -1)), _cache[11] || (_cache[11] = _createElementVNode("p", {
        class: "mb-4 text-gray-800"
      }, " LeanLaw's expense import tool is designed to assist you in uploading expenses in bulk. To prepare your bulk expense import, first you will need to ensure you have your expense data formatted appropriately. You can download the sample expense import template to use to input your data and make sure you have the right format. ", -1)), _cache[12] || (_cache[12] = _createElementVNode("p", {
        class: "mb-4 text-gray-800"
      }, " You will also need information about clients and matters to make sure your expenses are assigned appropriately. You can get a list of all clients and matters to use as you build your file. Once your file is ready to upload, you will begin the upload process, map the column titles to the right LeanLaw fields, confirm the validated data, and then complete the import. ", -1)), _createElementVNode("div", _hoisted_5, [_cache[9] || (_cache[9] = _createElementVNode("div", null, [_createElementVNode("h2", {
        class: "text-lg font-semibold text-black mb-2"
      }, " Export matters: "), _createElementVNode("p", {
        class: "mb-4 text-gray-800"
      }, " Get a list of all clients and matters to use as you build your csv file ")], -1)), _createElementVNode("div", null, [_createVNode(LlSecondaryButton, {
        variant: "outlined",
        onBtnClick: _cache[1] || (_cache[1] = $event => downloadMatters()),
        "prepend-icon": "mdi-tray-arrow-down"
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" Download Matters ", -1)]))]),
        _: 1
      })])]), _cache[13] || (_cache[13] = _createStaticVNode("<div class=\"mb-6 flex justify-between items-center\"><div><h2 class=\"text-lg font-semibold text-black mb-2\"> Sample expense template: </h2><p class=\"mb-4 text-gray-800\"> If you click on &quot;Begin Expense Import&quot; you will see a new window pop up. In the bottom left corner of that window, you will get an option to &quot;Download Excel template&quot;. You can use this template to build your expense import file. Please note the following: </p><ul class=\"list-disc list-inside mb-4 text-black\"><li class=\"text-gray-800\"> Do not use any currency symbols in the Amount column. </li><li class=\"text-gray-800\"> The &quot;User&quot;, &quot;Expense Code&quot;, &quot;Vendor&quot;, and &quot;Expense Type&quot; are all optional fields. </li><li class=\"text-gray-800\"> The &quot;Expense Type&quot; field can have values of &quot;LeanLaw&quot; or &quot;QBO Bill&quot;. The field will default to &quot;LeanLaw&quot; if not filled out. If &quot;QBO Bill&quot; is indicated, the &quot;Vendor&quot; field becomes a required field. </li></ul></div></div>", 1))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[15] || (_cache[15] = _createElementVNode("div", null, [_createElementVNode("h2", {
        class: "text-lg text-black font-semibold mb-2"
      }, " Upload expenses in bulk: "), _createElementVNode("p", {
        class: "mb-4 text-gray-800"
      }, " Browse and select a CSV file to import. ")], -1)), _createElementVNode("div", null, [_createVNode(LlSecondaryButton, {
        variant: "flat",
        color: "primary",
        onBtnClick: _cache[2] || (_cache[2] = $event => _unref(initiateSession)('expense')),
        "prepend-icon": "mdi-tray-arrow-up",
        class: "my-2"
      }, {
        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode(" Begin Expense Import ", -1)]))]),
        _: 1
      })])]), _createVNode(_component_v_card, null, {
        default: _withCtx(() => [_createVNode(_component_v_card_title, null, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("Imports", -1)]))]),
          _: 1
        }), _unref(loading) ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Loading...")) : (_openBlock(), _createBlock(_component_v_table, {
          key: 1,
          density: "compact",
          class: "table-container"
        }, {
          default: _withCtx(() => [_cache[19] || (_cache[19] = _createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", null, "Id"), _createElementVNode("th", null, "Status"), _createElementVNode("th", {
            class: "text-center"
          }, "Expenses"), _createElementVNode("th", {
            class: "text-center"
          }, " ")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expenseImports(_unref(imports)), item => {
            return _openBlock(), _createElementBlock("tr", {
              key: item.id
            }, [_createElementVNode("td", null, _toDisplayString(item.id), 1), _createElementVNode("td", null, _toDisplayString(item.status), 1), _createElementVNode("td", _hoisted_9, _toDisplayString(displayCount(item, 'expenses')), 1), _createElementVNode("td", null, [item.showUndo ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 0,
              onClick: $event => confirmUndo(item.id)
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("mdi-delete", -1)]))]),
              _: 1
            }, 8, ["onClick"])) : _createCommentVNode("", true), item.showComplete ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 1,
              onClick: $event => confirmComplete(item.id)
            }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("mdi-import", -1)]))]),
              _: 1
            }, 8, ["onClick"])) : _createCommentVNode("", true)])]);
          }), 128))])]),
          _: 1
        }))]),
        _: 1
      }), state.result ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card_title, null, {
          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode("Results", -1)]))]),
          _: 1
        }), _createElementVNode("span", {
          class: _normalizeClass([state.result.success ? 'text-green-light' : 'text-error', "pl-4"])
        }, _toDisplayString(state.result.success ? 'Success' : 'Errors'), 3), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.result.errors, error => {
          return _openBlock(), _createElementBlock("li", {
            key: error.id
          }, [_createTextVNode(_toDisplayString(error.message), 1), _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)), _createTextVNode(" " + _toDisplayString(error.exception), 1)]);
        }), 128))])]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_v_dialog, {
        modelValue: state.undoDialog,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => state.undoDialog = $event),
        "max-width": "290"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, null, {
          default: _withCtx(() => [_createVNode(_component_v_card_title, {
            class: "headline"
          }, {
            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode("Confirm Undo", -1)]))]),
            _: 1
          }), _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode(" Are you sure you want to delete all the items related to this import? It cannot be undone. If the client has made changes to the data, it cannot be recovered.", -1)]))]),
            _: 1
          }), _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [_createVNode(LlSecondaryButton, {
              onBtnClick: _cache[3] || (_cache[3] = $event => state.undoDialog = false)
            }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode(" Cancel ", -1)]))]),
              _: 1
            }), _createVNode(LlSecondaryButton, {
              color: "primary",
              variant: "text",
              onBtnClick: undoItem
            }, {
              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode(" Undo ", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_v_dialog, {
        modelValue: state.completeDialog,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => state.completeDialog = $event),
        "max-width": "290"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, null, {
          default: _withCtx(() => [_createVNode(_component_v_card_title, {
            class: "headline"
          }, {
            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode("Confirm Complete Import", -1)]))]),
            _: 1
          }), _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [_createTextVNode(" Are you sure you want to insert all the items for this import into the firm? ", -1)]))]),
            _: 1
          }), _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [_createVNode(LlSecondaryButton, {
              onBtnClick: _cache[5] || (_cache[5] = $event => state.completeDialog = false)
            }, {
              default: _withCtx(() => [...(_cache[28] || (_cache[28] = [_createTextVNode("Cancel", -1)]))]),
              _: 1
            }), _createVNode(LlSecondaryButton, {
              color: "primary",
              variant: "text",
              onBtnClick: completeItem
            }, {
              default: _withCtx(() => [...(_cache[29] || (_cache[29] = [_createTextVNode("Go!", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])])])]);
    };
  }
};